// extracted by mini-css-extract-plugin
export default {"inner":"m3Jm0KQMtkcTJuwPxz8Q"};